import { useEffect } from "react";
import { useAvailableSecurityAdminsSites } from "src/features/security/hooks/api/use-available-security-admins-sites";
import { useSiteAdminsProfile } from "src/features/site-management/hooks/api/admins/use-site-admins-profile";
import { useAdminsProfile } from "../features/organization/hooks/api/admins/use-admins-profile";
import useStore from "./use-store";

export const useSetInitialOrganizations = (enabled: boolean = true) => {
  const { user } = useStore();

  const organizationAdminQuery = useAdminsProfile(enabled);
  const siteAdminQuery = useSiteAdminsProfile(enabled);
  const securityAdminQuery = useAvailableSecurityAdminsSites(enabled);

  useEffect(() => {
    if (organizationAdminQuery?.data?.actualOrganization && !user.userOrganizationId) {
      user.setUserOrganizationId(organizationAdminQuery.data?.actualOrganization?.token);
    }

    if (siteAdminQuery.data?.sites?.length > 0 && !user.siteToken) {
      user.setSiteToken(siteAdminQuery.data?.sites?.[0]?.token);
      user.setSiteTimeZone(siteAdminQuery.data?.sites?.[0]?.timezone || "Europe/Warsaw");
    }

    if (securityAdminQuery.data?.length > 0 && !user.siteToken) {
      user.setSiteToken(securityAdminQuery.data?.[0]?.token);
      user.setSiteTimeZone(securityAdminQuery.data?.[0]?.timezone || "Europe/Warsaw");
    }
  }, [
    organizationAdminQuery.data?.organizations,
    siteAdminQuery.data?.sites,
    securityAdminQuery.data,
    user.siteToken,
    user.userOrganizationId,
    user.siteTimeZone,
  ]);
};
